/*
 * Winy Mind Pvt. Ltd.
 * Created by suraj on 23/01/24, 5:57 pm
 * Copyright (c) 2024 . All rights reserved.
 * Last modified 23/01/24, 5:57 pm
 */

package tta.destinigo.talktoastro.feature_chat_consultation_new.data.response.geo_details

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable


@Serializable
data class GeoName(
    @SerialName("country_code") val countryCode: String, // IN
    @SerialName("latitude") val latitude: Double, // 19.07283
    @SerialName("longitude") val longitude: Double, // 72.88261
    @SerialName("place_name") val placeName: String, // Mumbai
    @SerialName("timezone_id") val timezoneId: String // Asia/Kolkata
)